const bottlebooksProfileFields: BottlebooksField[] = [
  { label: 'Company name', key: 'profile.name', required: false },
  { label: 'Logo', key: 'profile.logoUrl', required: false },
  { label: 'Country', key: 'profile.country', required: false },
  { label: 'City', key: 'profile.city', required: false },
  { label: 'Street', key: 'profile.street.0.line', required: false },
  { label: 'State', key: 'profile.state', required: false },
  { label: 'Postal code', key: 'profile.postalCode', required: false },
  { label: 'Telephone', key: 'profile.telephone', required: false },
  { label: 'Main picture', key: 'profile.mainPicture', required: false },
  { label: 'Latitude', key: 'profile.latitude', required: false },
  { label: 'Longitude', key: 'profile.longitude', required: false },
  {
    label: 'Description (English)',
    key: 'profile.localizedData.en_US.description',
    required: false,
  },
  {
    label: 'Description (French)',
    key: 'profile.localizedData.fr_FR.description',
    required: false,
  },
  {
    label: 'Description (German)',
    key: 'profile.localizedData.de_DE.description',
    required: false,
  },
  {
    label: 'Description (Italian)',
    key: 'profile.localizedData.it_IT.description',
    required: false,
  },
  {
    label: 'Description (Portuguese)',
    key: 'profile.localizedData.pt_PT.description',
    required: false,
  },
  {
    label: 'Description (Slovak)',
    key: 'profile.localizedData.sk_SK.description',
    required: false,
  },
  {
    label: 'Description (Spanish)',
    key: 'profile.localizedData.es_ES.description',
    required: false,
  },
  {
    label: 'Short description (English)',
    key: 'profile.localizedData.en_US.shortDescription',
    required: false,
  },
  {
    label: 'Short description (French)',
    key: 'profile.localizedData.fr_FR.shortDescription',
    required: false,
  },
  {
    label: 'Short description (German)',
    key: 'profile.localizedData.de_DE.shortDescription',
    required: false,
  },
  {
    label: 'Short description (Italian)',
    key: 'profile.localizedData.it_IT.shortDescription',
    required: false,
  },
  {
    label: 'Short description (Portuguese)',
    key: 'profile.localizedData.pt_PT.shortDescription',
    required: false,
  },
  {
    label: 'Short description (Slovak)',
    key: 'profile.localizedData.sk_SK.shortDescription',
    required: false,
  },
  {
    label: 'Short description (Spanish)',
    key: 'profile.localizedData.es_ES.shortDescription',
    required: false,
  },
  { label: 'Website', key: 'profile.website', required: false },
  { label: 'Email', key: 'profile.email', required: false },
  { label: 'Facebook', key: 'profile.facebook', required: false },
  { label: 'Instagram', key: 'profile.instagram', required: false },
  { label: 'Twitter', key: 'profile.twitter', required: false },
];
export default bottlebooksProfileFields;

type BottlebooksField = {
  label: string;
  key: string;
  required: boolean;
};
